import React, {useEffect, useRef} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera as faCameraRegular } from '@fortawesome/free-regular-svg-icons';
import {BrowserMultiFormatReader} from "@zxing/library";

// Barcode Scanner Modal Component
const BarcodeModal = ({ setBarcodeModal, handleScanResult }) => {
  const videoRef = useRef(null);
  const codeReader = useRef(null);

  useEffect(() => {
    codeReader.current = new BrowserMultiFormatReader();
    return () => {
      if (codeReader.current) {
        codeReader.current.reset();
      }
    };
  }, []);

  return (
      <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
      >
        <div
            className="bg-white rounded-lg shadow-xl w-full max-w-sm">{/* Removed positioning classes */}
          <div className="flex justify-between items-center p-4 border-b">
            <h3 className="text-lg font-semibold">Barcode scannen</h3>
            <button
                onClick={() => setBarcodeModal(false)}
                className="text-gray-500 hover:text-gray-700 text-xl"
            >
              ×
            </button>
          </div>
          <div className="p-4 space-y-4">
            <p className="text-sm text-gray-600">
              Richten Sie die Kamera auf den Barcode/QR-Code
            </p>
            <div className="relative">
              <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  muted
                  className="w-full h-48 bg-black rounded"
              />
            </div>
            <div className="flex space-x-3">
              <button
                  onClick={() => setBarcodeModal(false)}
                  className="flex-1 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
              >
                Abbrechen
              </button>
              <button
                  onClick={() => {
                    if (videoRef.current && codeReader.current) {
                      codeReader.current.decodeOnceFromVideoDevice(undefined,
                          videoRef.current)
                          .then((result) => {
                            handleScanResult(result.text);
                          })
                          .catch((err) => {
                            console.error('Barcode scan error:', err);
                            alert(
                                'Barcode konnte nicht gelesen werden. Versuchen Sie es erneut.');
                          });
                    } else {
                      alert(
                          'Kamera ist nicht bereit. Versuchen Sie es erneut.');
                    }
                  }}
                  className="flex-1 bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600"
              >
                <FontAwesomeIcon icon={faCameraRegular} className="mr-2"/>
                Aufnehmen
              </button>
            </div>
          </div>
        </div>
      </div>
  );
}

export default BarcodeModal;
